/**
 * České skloňování počtů.
 *
 * Čeština má tři tvary, ne dva: 1 položka / 2–4 položky / 0 a 5+ položek.
 * Anglický vzor „1 items" vypadá v českém obchodě jako chyba překladu,
 * a přesně to výloha psala („1 položek").
 */
export function plural(count: number, one: string, few: string, many: string): string {
  if (count === 1) return one;
  if (count >= 2 && count <= 4) return few;
  return many;
}

/** Nejčastější případ: počet zboží ve výpisu. */
export function itemWord(count: number): string {
  return plural(count, 'položka', 'položky', 'položek');
}
